import { render, staticRenderFns } from "./FAQFastFingersComponent.vue?vue&type=template&id=5d468e4e&scoped=true&"
import script from "./FAQFastFingersComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQFastFingersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQFastFingersComponent.vue?vue&type=style&index=0&id=5d468e4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d468e4e",
  null
  
)

export default component.exports